import { createClient } from '@supabase/supabase-js'
import { createSupabaseClient } from './supabaseDynamic'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://njbmupxckghcpfmadgbw.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || 'sb_publishable_rRQ3O_r0KSCV8DgOI6ZAAw_hTkgguf2'

export const supabase = createSupabaseClient(supabaseUrl, supabaseKey)

// Client strictement anonyme pour amorcer le groupe et appeler l'auth Edge.
// Il ne lit ni n'écrit la session persistée et ne peut donc pas concurrencer
// le verrou du client Auth principal.
export const supabaseBootstrap = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
    storageKey: 'crm-clubs-bootstrap-anonyme',
  },
})
